export enum CampaignsRoutes {
  CampaignServices = 'campaign-services',
  CampaignManagementTaskBoard = 'campaign-management-task-board',
  CampaignManagementTaskGrid = 'campaign-management-task-grid',
}
